import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

interface SaveSlotSelectProps {
  localStorageSupported?: boolean
  saveSlot: string
  setSaveSlot: React.Dispatch<React.SetStateAction<string | '' | FUNDING_RATE_CHART_LOCAL_STORAGE_QUICKSAVE_KEY>>
}

enum FUNDING_RATE_CHART_LOCAL_STORAGE_QUICKSAVE_KEY {
  SLOT_1 = 'funding-rate-chart-slot-1',
  SLOT_2 = 'funding-rate-chart-slot-2',
  SLOT_3 = 'funding-rate-chart-slot-3',
  SLOT_4 = 'funding-rate-chart-slot-4',
  SLOT_5 = 'funding-rate-chart-slot-5',
}

const FRSaveSlotSelect: React.FC<SaveSlotSelectProps> = (props) => {
  const { localStorageSupported = true, saveSlot, setSaveSlot } = props

  return (
    <FormControl variant='standard' size='small' sx={{ flexGrow: 1 }}>
      <InputLabel id='save-slot-select-label'>{localStorageSupported ? 'Save Slot' : 'API Not Available'}</InputLabel>
      <Select
        labelId='save-slot-select-label'
        id='save-slot-select'
        label={localStorageSupported ? 'Save Slot' : 'API Not Available'}
        value={saveSlot}
        onChange={event => {
          setSaveSlot(event.target.value as FUNDING_RATE_CHART_LOCAL_STORAGE_QUICKSAVE_KEY)
        }}
        disabled={!localStorageSupported}
      >
        {
          Object.entries(FUNDING_RATE_CHART_LOCAL_STORAGE_QUICKSAVE_KEY)
            .map(([key, value]) => {
              return (<MenuItem key={key} value={value}>{key.replaceAll('_', ' ')}</MenuItem>)
            })
        }
      </Select>
    </FormControl>
  )
}

export default FRSaveSlotSelect
